module.exports = __webpack_public_path__ + "static/media/logo_dsk.07b0dbff.svg";